// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/procurement_plan_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { JepxSpotPortion, PlanConsistencyStatus, PlanSourceType, PlanSubmissionStatus, PlanTimeframe } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/procurement_plan_model.proto.
 */
export const file_bffuser_v1_procurement_plan_model: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ1c2VyL3YxL3Byb2N1cmVtZW50X3BsYW5fbW9kZWwucHJvdG8SCmJmZnVzZXIudjEiMAoIUGxhblNsb3QSFgoJdmFsdWVfa3doGAEgASgDSACIAQFCDAoKX3ZhbHVlX2t3aCKYAwoXUHJvY3VyZW1lbnRQbGFuVmFsdWVSb3cSCgoCaWQYASABKAkSMAoLc291cmNlX3R5cGUYAiABKA4yGy5iZmZ0eXBlcy52MS5QbGFuU291cmNlVHlwZRIeChFjb3VudGVycGFydHlfY29kZRgDIAEoCUgAiAEBEh4KEWNvdW50ZXJwYXJ0eV9uYW1lGAQgASgJSAGIAQESGAoLY29udHJhY3RfaWQYBSABKAlIAogBARIjCgVzbG90cxgGIAMoCzIULmJmZnVzZXIudjEuUGxhblNsb3QSNwoRamVweF9zcG90X3BvcnRpb24YByABKA4yHC5iZmZ0eXBlcy52MS5KZXB4U3BvdFBvcnRpb24SHwoSc291cmNlX2NvbnRyYWN0X2lkGAkgASgJSAOIAQFCFAoSX2NvdW50ZXJwYXJ0eV9jb2RlQhQKEl9jb3VudGVycGFydHlfbmFtZUIOCgxfY29udHJhY3RfaWRCFQoTX3NvdXJjZV9jb250cmFjdF9pZEoECAgQCVINc291cmNlX2xlZ19pZCLzAQoXUHJldmlvdXNTdWJtaXR0ZWRWYWx1ZXMSMAoMc3VibWl0dGVkX2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIqCgxkZW1hbmRfc2xvdHMYAiADKAsyFC5iZmZ1c2VyLnYxLlBsYW5TbG90Ej8KEnByb2N1cmVtZW50X3ZhbHVlcxgDIAMoCzIjLmJmZnVzZXIudjEuUHJvY3VyZW1lbnRQbGFuVmFsdWVSb3cSOQoMc2FsZXNfdmFsdWVzGAQgAygLMiMuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5WYWx1ZVJvdyKGDQoVUHJvY3VyZW1lbnRQbGFuRGV0YWlsEgoKAmlkGAEgASgJEi0KCXRpbWVmcmFtZRgCIAEoDjIaLmJmZnR5cGVzLnYxLlBsYW5UaW1lZnJhbWUSMwoYdGFyZ2V0X3BlcmlvZF9zdGFydF9kYXRlGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIoCglhcmVhX2NvZGUYBCABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIPCgdiZ19jb2RlGAUgASgJEhQKB2JnX25hbWUYBiABKAlIAIgBARIxCgZzdGF0dXMYByABKA4yIS5iZmZ0eXBlcy52MS5QbGFuU3VibWlzc2lvblN0YXR1cxIPCgd2ZXJzaW9uGAggASgFEjMKD2ZpbGVfY3JlYXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASNQoMc3VibWl0dGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEioKDGRlbWFuZF9zbG90cxgLIAMoCzIULmJmZnVzZXIudjEuUGxhblNsb3QSPwoScHJvY3VyZW1lbnRfdmFsdWVzGAwgAygLMiMuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5WYWx1ZVJvdxI5CgxzYWxlc192YWx1ZXMYDSADKAsyIy5iZmZ1c2VyLnYxLlByb2N1cmVtZW50UGxhblZhbHVlUm93EkQKEnByZXZpb3VzX3N1Ym1pdHRlZBgOIAEoCzIjLmJmZnVzZXIudjEuUHJldmlvdXNTdWJtaXR0ZWRWYWx1ZXNIAogBARIuCgp1cGRhdGVkX2F0GA8gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBJAChNyZXRhaWxlcl9icmVha2Rvd25zGBAgAygLMiMuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5SZXRhaWxlchJDChByZWNlcHRpb25fZXJyb3JzGBEgAygLMikuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5SZWNlcHRpb25FcnJvchJGCg5lcnJvcl9jYXRlZ29yeRgSIAEoDjIuLmJmZnVzZXIudjEuUHJvY3VyZW1lbnRQbGFuU3VibWl0RXJyb3JDYXRlZ29yeRIdChVleGNsdWRlZF9rb21hX251bWJlcnMYEyADKAUSPgoTc3VibWl0X2Jsb2NrX3JlYXNvbhgUIAEoDjIhLmJmZnVzZXIudjEuUGxhblN1Ym1pdEJsb2NrUmVhc29uEiYKGWxhdGVzdF9wbGFuX3N1Ym1pc3Npb25faWQYFSABKAlIA4gBARItCiVyZWNlaXB0X2NoZWNrX3N1c3BlbmRlZF9ieV9jYWxsX2xpbWl0GBYgASgIEhkKDHN1Ym1pdHRlZF9ieRgXIAEoCUgEiAEBEikKIWNyZWRlbnRpYWxfcmVqZWN0aW9uX3Jlc3VsdF9jb2RlcxgYIAMoCRIVCg1zZW5kX3JldHJ5aW5nGBkgASgIEi4KJmludGVybmFsX2JhbGFuY2VfbWlzbWF0Y2hfa29tYV9udW1iZXJzGBogAygFEl4KI2ludGVybmFsX3JldGFpbGVyX2RlbWFuZF9taXNtYXRjaGVzGBsgAygLMjEuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5SZXRhaWxlckRlbWFuZE1pc21hdGNoEj8KFnN1Ym1pc3Npb25fZGVhZGxpbmVfYXQYHCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAWIAQESJQodY3JlYXRpb25fYWxpZ25lZF9rb21hX251bWJlcnMYHSADKAUSIAoTYnJlYWtkb3duX3Jvd19saW1pdBgeIAEoBUgGiAEBEigKIGJpZHNfYXdhaXRpbmdfbWF0Y2hfcmVzdWx0X2NvdW50GB8gASgFEiIKGnNwb3RfdHJhZGVfcmVzdWx0X21pc21hdGNoGCAgASgIQgoKCF9iZ19uYW1lQg8KDV9zdWJtaXR0ZWRfYXRCFQoTX3ByZXZpb3VzX3N1Ym1pdHRlZEIcChpfbGF0ZXN0X3BsYW5fc3VibWlzc2lvbl9pZEIPCg1fc3VibWl0dGVkX2J5QhkKF19zdWJtaXNzaW9uX2RlYWRsaW5lX2F0QhYKFF9icmVha2Rvd25fcm93X2xpbWl0Ik4KJVByb2N1cmVtZW50UGxhblJldGFpbGVyRGVtYW5kTWlzbWF0Y2gSEwoLa29tYV9udW1iZXIYASABKAUSEAoIZGlmZl9rd2gYAiABKAMisQIKF1Byb2N1cmVtZW50UGxhblJldGFpbGVyEhUKDXJldGFpbGVyX2NvZGUYASABKAkSGgoNcmV0YWlsZXJfbmFtZRgCIAEoCUgAiAEBEg4KBmlzX293bhgDIAEoCBIqCgxkZW1hbmRfc2xvdHMYBCADKAsyFC5iZmZ1c2VyLnYxLlBsYW5TbG90Ej8KEnByb2N1cmVtZW50X3ZhbHVlcxgFIAMoCzIjLmJmZnVzZXIudjEuUHJvY3VyZW1lbnRQbGFuVmFsdWVSb3cSOQoMc2FsZXNfdmFsdWVzGAYgAygLMiMuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5WYWx1ZVJvdxIZChFpc19yZXByZXNlbnRhdGl2ZRgHIAEoCEIQCg5fcmV0YWlsZXJfbmFtZSJRCgxSZXRhaWxlckluZm8SGgoSYnVzaW5lc3NfbWFzdGVyX2lkGAEgASgJEhUKDWJ1c2luZXNzX25hbWUYAiABKAkSDgoGaXNfb3duGAMgASgIItAIChJQcm9jdXJlbWVudFBsYW5Sb3cSCgoCaWQYASABKAkSLQoJdGltZWZyYW1lGAIgASgOMhouYmZmdHlwZXMudjEuUGxhblRpbWVmcmFtZRIzChh0YXJnZXRfcGVyaW9kX3N0YXJ0X2RhdGUYAyABKAsyES5nb29nbGUudHlwZS5EYXRlEigKCWFyZWFfY29kZRgEIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEg8KB2JnX2NvZGUYBSABKAkSFAoHYmdfbmFtZRgGIAEoCUgAiAEBEjEKBnN0YXR1cxgHIAEoDjIhLmJmZnR5cGVzLnYxLlBsYW5TdWJtaXNzaW9uU3RhdHVzEg8KB3ZlcnNpb24YCCABKAUSMwoPZmlsZV9jcmVhdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI1CgxzdWJtaXR0ZWRfYXQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESEwoLd29ya2Zsb3dfaWQYDCABKAkSPwoOY291bnRlcnBhcnRpZXMYDSADKAsyJy5iZmZ1c2VyLnYxLlByb2N1cmVtZW50UGxhbkNvdW50ZXJwYXJ0eRJDChByZWNlcHRpb25fZXJyb3JzGA4gAygLMikuYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5SZWNlcHRpb25FcnJvchJGCg5lcnJvcl9jYXRlZ29yeRgPIAEoDjIuLmJmZnVzZXIudjEuUHJvY3VyZW1lbnRQbGFuU3VibWl0RXJyb3JDYXRlZ29yeRIdChVleGNsdWRlZF9rb21hX251bWJlcnMYECADKAUSGAoQd29ya2Zsb3dfY2FzZV9pZBgRIAEoCRI+ChJjb25zaXN0ZW5jeV9zdGF0dXMYEiABKA4yIi5iZmZ0eXBlcy52MS5QbGFuQ29uc2lzdGVuY3lTdGF0dXMSLQolcmVjZWlwdF9jaGVja19zdXNwZW5kZWRfYnlfY2FsbF9saW1pdBgTIAEoCBIzCg9sYXN0X3VwZGF0ZWRfYXQYFCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhUKDXNlbmRfcmV0cnlpbmcYFSABKAgSLAokY291bnRlcnBhcnR5X21pc21hdGNoZXNfYWxsX3Jlc29sdmVkGBYgASgIEiAKE2JyZWFrZG93bl9yb3dfbGltaXQYFyABKAVIAogBARIoCiBiaWRzX2F3YWl0aW5nX21hdGNoX3Jlc3VsdF9jb3VudBgYIAEoBRIiChpzcG90X3RyYWRlX3Jlc3VsdF9taXNtYXRjaBgZIAEoCEIKCghfYmdfbmFtZUIPCg1fc3VibWl0dGVkX2F0QhYKFF9icmVha2Rvd25fcm93X2xpbWl0SgQICxAMUhloYXNfZGVtYW5kX2ZvcmVjYXN0X2Jhc2lzIn8KG1Byb2N1cmVtZW50UGxhbkNvdW50ZXJwYXJ0eRIZChFjb3VudGVycGFydHlfY29kZRgBIAEoCRIeChFjb3VudGVycGFydHlfbmFtZRgCIAEoCUgAiAEBEg8KB2lzX2plcHgYAyABKAhCFAoSX2NvdW50ZXJwYXJ0eV9uYW1lIkoKHVByb2N1cmVtZW50UGxhblJlY2VwdGlvbkVycm9yEhIKCmVycm9yX2NvZGUYASABKAkSFQoNZXJyb3JfbWVzc2FnZRgCIAEoCSqjBgoiUHJvY3VyZW1lbnRQbGFuU3VibWl0RXJyb3JDYXRlZ29yeRI2CjJQUk9DVVJFTUVOVF9QTEFOX1NVQk1JVF9FUlJPUl9DQVRFR09SWV9VTlNQRUNJRklFRBAAEj4KOlBST0NVUkVNRU5UX1BMQU5fU1VCTUlUX0VSUk9SX0NBVEVHT1JZX1BMQU5fTUFTVEVSX01JU1NJTkcQARJGCkJQUk9DVVJFTUVOVF9QTEFOX1NVQk1JVF9FUlJPUl9DQVRFR09SWV9ERU1BTkRfRk9SRUNBU1RfVU5DT05GSVJNRUQQAhJBCj1QUk9DVVJFTUVOVF9QTEFOX1NVQk1JVF9FUlJPUl9DQVRFR09SWV9TT1VSQ0VfREFUQV9JTkNPTVBMRVRFEAMSRApAUFJPQ1VSRU1FTlRfUExBTl9TVUJNSVRfRVJST1JfQ0FURUdPUllfQ1JFREVOVElBTF9OT1RfQ09ORklHVVJFRBAEEjoKNlBST0NVUkVNRU5UX1BMQU5fU1VCTUlUX0VSUk9SX0NBVEVHT1JZX1JFVFJZX0VYSEFVU1RFRBAFEjAKLFBST0NVUkVNRU5UX1BMQU5fU1VCTUlUX0VSUk9SX0NBVEVHT1JZX09USEVSEAYSPwo7UFJPQ1VSRU1FTlRfUExBTl9TVUJNSVRfRVJST1JfQ0FURUdPUllfR0FURV9DTE9TRURfQUxMX0tPTUEQBxI9CjlQUk9DVVJFTUVOVF9QTEFOX1NVQk1JVF9FUlJPUl9DQVRFR09SWV9DUkVERU5USUFMX0lOVkFMSUQQCBI8CjhQUk9DVVJFTUVOVF9QTEFOX1NVQk1JVF9FUlJPUl9DQVRFR09SWV9PQ0NUT19VTlJFQUNIQUJMRRAJEkMKP1BST0NVUkVNRU5UX1BMQU5fU1VCTUlUX0VSUk9SX0NBVEVHT1JZX09DQ1RPX0NBTExfTElNSVRfUkVBQ0hFRBAKEkMKP1BST0NVUkVNRU5UX1BMQU5fU1VCTUlUX0VSUk9SX0NBVEVHT1JZX0JSRUFLRE9XTl9MSU1JVF9FWENFRURFRBALKvkBChlQbGFuU3VibWlzc2lvbkVycm9yUmVhc29uEiwKKFBMQU5fU1VCTUlTU0lPTl9FUlJPUl9SRUFTT05fVU5TUEVDSUZJRUQQABJACjxQTEFOX1NVQk1JU1NJT05fRVJST1JfUkVBU09OX09DQ1RPX0NSRURFTlRJQUxfTk9UX0NPTkZJR1VSRUQQARIzCi9QTEFOX1NVQk1JU1NJT05fRVJST1JfUkVBU09OX1NVUEVSU0VERURfVkVSU0lPThACEjcKM1BMQU5fU1VCTUlTU0lPTl9FUlJPUl9SRUFTT05fTUlTU0lOR19CQVNFTElORV9CT1hFUxADKtkBChVQbGFuU3VibWl0QmxvY2tSZWFzb24SKAokUExBTl9TVUJNSVRfQkxPQ0tfUkVBU09OX1VOU1BFQ0lGSUVEEAASLworUExBTl9TVUJNSVRfQkxPQ0tfUkVBU09OX1NVUEVSU0VERURfVkVSU0lPThABEjMKL1BMQU5fU1VCTUlUX0JMT0NLX1JFQVNPTl9NSVNTSU5HX0JBU0VMSU5FX0JPWEVTEAISMAosUExBTl9TVUJNSVRfQkxPQ0tfUkVBU09OX05FV19WRVJTSU9OX0NSRUFURUQQA0JAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * PlanSlot represents a single 30-minute time slot value (kWh) within a
 * 48-slot planning day. optional allows distinguishing "not entered" (absent)
 * from "explicitly zero" (value = 0). The absence of a value means the slot
 * has not been filled in by the user.
 *
 * @generated from message bffuser.v1.PlanSlot
 */
export type PlanSlot = Message<"bffuser.v1.PlanSlot"> & {
  /**
   * Energy value in kWh for this slot. Absent means the slot is not entered;
   * 0 means explicitly zero. int64 is used because plan values are always
   * integer kWh (domain-knowledge §16).
   *
   * @generated from field: optional int64 value_kwh = 1;
   */
  valueKwh?: bigint;
};

/**
 * Describes the message bffuser.v1.PlanSlot.
 * Use `create(PlanSlotSchema)` to create a new message.
 */
export const PlanSlotSchema: GenMessage<PlanSlot> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 0);

/**
 * ProcurementPlanValueRow is a single breakdown row (取引先別内訳行) returned
 * from GetProcurementPlanDetail. The id field is the DB internal surrogate key
 * and is present for display reference only — it is never sent back in a
 * mutation: the detail screen is read-only (values are produced by the
 * generate worker), and SubmitProcurementPlan carries only the plan_id (no
 * value payload); there is no SaveProcurementPlanDraft RPC.
 *
 * @generated from message bffuser.v1.ProcurementPlanValueRow
 */
export type ProcurementPlanValueRow = Message<"bffuser.v1.ProcurementPlanValueRow"> & {
  /**
   * DB internal surrogate key. Present for reference only; not used in
   * mutations (full replacement strategy).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Source type of this breakdown row (e.g. BG bilateral, JEPX spot).
   * Provisional value domain — see residual issue #890.
   *
   * @generated from field: bfftypes.v1.PlanSourceType source_type = 2;
   */
  sourceType: PlanSourceType;

  /**
   * OCCTO 取引相手コード / counterparty BG code (JP06366). Market sources (JEPX
   * spot / intraday) carry the institutional code (JSPT3 / J1HR3); 他社 bilateral
   * rows carry the counterparty BG code.
   *
   * @generated from field: optional string counterparty_code = 3;
   */
  counterpartyCode?: string;

  /**
   * Display name of the counterparty. For JEPX スポット調達 it is the 区分名
   * (調達先未定分 / 相対契約分); for 他社 the trading-partner-master 略称 when
   * the code resolves to one partner, otherwise the name recorded on the plan.
   * Absent when no name is available (the plan master's 取引先コード名称 was
   * blank, or the 他社 BG master record was deleted).
   *
   * @generated from field: optional string counterparty_name = 4;
   */
  counterpartyName?: string;

  /**
   * Contract identifier that forms part of the business-key uniqueness
   * constraint for this row. Absent when not applicable.
   *
   * @generated from field: optional string contract_id = 5;
   */
  contractId?: string;

  /**
   * 48 ordered slots for the planning day (index 0 = 00:00, index 47 = 23:30).
   * Always exactly 48 elements when returned from the backend.
   *
   * @generated from field: repeated bffuser.v1.PlanSlot slots = 6;
   */
  slots: PlanSlot[];

  /**
   * JEPX スポット調達行の 調達先未定分 / 相対契約分 区分。販売スポット・時間前・他社行は
   * UNSPECIFIED。詳細画面が counterparty_name 文字列照合に依存せず 2 列を振り分ける信号。
   *
   * @generated from field: bfftypes.v1.JepxSpotPortion jepx_spot_portion = 7;
   */
  jepxSpotPortion: JepxSpotPortion;

  /**
   * Source contract identifier (UUID, trading_contract.id). Present for
   * 相対 (bilateral) contract rows, including 0-filled inherited boxes
   * (which retain the previous version's source_contract_id and thus
   * survive as their own column). Absent for JEPX market rows. Used as the
   * split key for 取引毎 display mode; 取引先毎合計 mode aggregates rows
   * sharing the same counterparty_code.
   *
   * **既存 contract_id (field 5) とは別物**: contract_id は OCCTO XML 契約
   * 参照の情報カラムで本 identifier とは無関係。
   *
   * @generated from field: optional string source_contract_id = 9;
   */
  sourceContractId?: string;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanValueRow.
 * Use `create(ProcurementPlanValueRowSchema)` to create a new message.
 */
export const ProcurementPlanValueRowSchema: GenMessage<ProcurementPlanValueRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 1);

/**
 * PreviousSubmittedValues carries the 48-slot values of the plan's 前回受理値
 * (the greatest earlier ACCEPTED / INCONSISTENT version of the same plan; see
 * previous_submitted). Used by the frontend to compute and render
 * per-cell diff highlights (前回差分表示).
 *
 * @generated from message bffuser.v1.PreviousSubmittedValues
 */
export type PreviousSubmittedValues = Message<"bffuser.v1.PreviousSubmittedValues"> & {
  /**
   * Timestamp at which the previous version was submitted.
   *
   * @generated from field: google.protobuf.Timestamp submitted_at = 1;
   */
  submittedAt?: Timestamp;

  /**
   * 48 demand slots from the previous submission.
   *
   * @generated from field: repeated bffuser.v1.PlanSlot demand_slots = 2;
   */
  demandSlots: PlanSlot[];

  /**
   * Procurement breakdown rows from the previous submission.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanValueRow procurement_values = 3;
   */
  procurementValues: ProcurementPlanValueRow[];

  /**
   * Sales breakdown rows from the previous submission.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanValueRow sales_values = 4;
   */
  salesValues: ProcurementPlanValueRow[];
};

/**
 * Describes the message bffuser.v1.PreviousSubmittedValues.
 * Use `create(PreviousSubmittedValuesSchema)` to create a new message.
 */
export const PreviousSubmittedValuesSchema: GenMessage<PreviousSubmittedValues> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 2);

/**
 * ProcurementPlanDetail is the full detail payload returned by
 * GetProcurementPlanDetail. It aggregates the plan header, 48-slot demand
 * values, procurement / sales breakdown rows, and optionally the previous
 * submitted version for diff display.
 *
 * Aggregate totals (調達合計 / 販売合計 / 需給バランス) are intentionally
 * omitted; the frontend computes them from the slot arrays.
 *
 * @generated from message bffuser.v1.ProcurementPlanDetail
 */
export type ProcurementPlanDetail = Message<"bffuser.v1.ProcurementPlanDetail"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Planning horizon.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 2;
   */
  timeframe: PlanTimeframe;

  /**
   * Start date of the target period covered by this submission.
   *
   * @generated from field: google.type.Date target_period_start_date = 3;
   */
  targetPeriodStartDate?: Date;

  /**
   * Supply area this submission is bound to.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * OCCTO BG code of the balancing group.
   *
   * @generated from field: string bg_code = 5;
   */
  bgCode: string;

  /**
   * Display name of the balancing group. Absent when the BG master record
   * has been deleted.
   *
   * @generated from field: optional string bg_name = 6;
   */
  bgName?: string;

  /**
   * Current processing status.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 7;
   */
  status: PlanSubmissionStatus;

  /**
   * Submission version number. Starts at 1 and increments on each
   * re-submission.
   *
   * @generated from field: int32 version = 8;
   */
  version: number;

  /**
   * Timestamp at which the plan XML file was created.
   *
   * @generated from field: google.protobuf.Timestamp file_created_at = 9;
   */
  fileCreatedAt?: Timestamp;

  /**
   * Timestamp at which the plan was submitted to the OCCTO portal.
   * Absent when the plan has not been submitted yet.
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 10;
   */
  submittedAt?: Timestamp;

  /**
   * 48 ordered demand slots (index 0 = 00:00, index 47 = 23:30).
   *
   * @generated from field: repeated bffuser.v1.PlanSlot demand_slots = 11;
   */
  demandSlots: PlanSlot[];

  /**
   * Procurement breakdown rows (取引先別調達内訳). Empty when no rows exist.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanValueRow procurement_values = 12;
   */
  procurementValues: ProcurementPlanValueRow[];

  /**
   * Sales breakdown rows (取引先別販売内訳). Empty when no rows exist.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanValueRow sales_values = 13;
   */
  salesValues: ProcurementPlanValueRow[];

  /**
   * Values of the 前回受理値: among the versions of the same plan (the 単日
   * 当日 / 翌日 / 翌々日 sections are one plan) with a smaller version number,
   * the greatest one in ACCEPTED or INCONSISTENT (受領済・不整合). Absent when
   * no such version exists.
   *
   * @generated from field: optional bffuser.v1.PreviousSubmittedValues previous_submitted = 14;
   */
  previousSubmitted?: PreviousSubmittedValues;

  /**
   * Optimistic-lock baseline. SubmitProcurementPlan carries no
   * expected_updated_at field (the enqueue tx re-verifies the version's
   * status server-side under the row lock); this field is exposed for
   * display / a future mutation RPC round-trip. There is no
   * SaveProcurementPlanDraft RPC.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * Small-retailer breakdown (BG/小売切替) for the retailers with a saved
   * roster. Populated only by GetProcurementPlanDetail; always empty on
   * GetProcurementPlanByFilter (no frontend consumer of the filter-lookup
   * path needs it yet, avoiding an unused payload cost on the list-adjacent
   * lookup RPC). Empty when the plan carries no saved roster (generation
   * path / pre-existing imports before this field was populated) — the
   * frontend disables the BG/小売 switch in that case.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanRetailer retailer_breakdowns = 16;
   */
  retailerBreakdowns: ProcurementPlanRetailer[];

  /**
   * OCCTO 受付エラー詳細 (BP エラーコード体系)。status = REJECTED かつ受付エラー
   * 詳細が取得済みの時のみ populate される。複数件は全件表示 (AC-PLC-033-1)。
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanReceptionError reception_errors = 17;
   */
  receptionErrors: ProcurementPlanReceptionError[];

  /**
   * 失敗原因の読み取り時分類。GENERATION_FAILED / SUBMIT_FAILED /
   * REJECTED(詳細なし) / SEND_FAILED (送信失敗の原因 4 区分) で populate、それ以外は
   * UNSPECIFIED
   * (internalapi.v1.PlanSubmissionDetailView.error_category の pass-through)。
   *
   * @generated from field: bffuser.v1.ProcurementPlanSubmitErrorCategory error_category = 18;
   */
  errorCategory: ProcurementPlanSubmitErrorCategory;

  /**
   * GC 経過により送信時に自動除外されたコマ番号 (1-origin, 1..48, 昇順)。
   * internalapi.v1.PlanSubmissionDetailView.excluded_koma_numbers の
   * pass-through (gc-excluded-koma-visibility design)。
   *
   * @generated from field: repeated int32 excluded_koma_numbers = 19;
   */
  excludedKomaNumbers: number[];

  /**
   * Why a user submission of this version would be rejected right now
   * (AC-PLC-055 / AC-PLC-056). Pass-through of
   * internalapi.v1.PlanSubmissionDetailView.submit_block_reason. When not
   * UNSPECIFIED the frontend shows the AC's guidance instead of the submit /
   * re-submit button (AC-PLC-020-2 note).
   *
   * @generated from field: bffuser.v1.PlanSubmitBlockReason submit_block_reason = 20;
   */
  submitBlockReason: PlanSubmitBlockReason;

  /**
   * Id of the version to open from the「最新の計画を開く」button. For
   * SUPERSEDED_VERSION the plan's latest version (the greatest not-soft-deleted
   * version, another one than this); for NEW_VERSION_CREATED the greatest
   * not-soft-deleted version of the same plan in the same business workflow.
   * Not set for other reasons (not the latest-only list row).
   * Pass-through of
   * internalapi.v1.PlanSubmissionDetailView.latest_plan_submission_id.
   *
   * @generated from field: optional string latest_plan_submission_id = 21;
   */
  latestPlanSubmissionId?: string;

  /**
   * 事業者コードが OCCTO 呼び出し回数上限 (0102) で受付照合を止めている間、
   * 提出済 / 受領確認待ちの処理中で true (AC-PLC-058)。
   * internalapi.v1.PlanSubmissionDetailView.receipt_check_suspended_by_call_limit
   * の pass-through (field 番号は main で 20 / 21 が
   * submit_block_reason / latest_plan_submission_id に使われたため 22)。
   *
   * @generated from field: bool receipt_check_suspended_by_call_limit = 22;
   */
  receiptCheckSuspendedByCallLimit: boolean;

  /**
   * 表示中の版の提出操作を行った利用者の eauth member ID (AC-PPD-027 /
   * AC-PLC-059)。submitted_at が無い版では absent。frontend が member 一覧で
   * 表示名へ解決し、生の ID は表示しない。
   * internalapi.v1.PlanSubmissionDetailView.submitted_by の pass-through。
   *
   * @generated from field: optional string submitted_by = 23;
   */
  submittedBy?: string;

  /**
   * internalapi.v1.PlanSubmissionDetailView.credential_rejection_result_codes の
   * pass-through (AC-PLC-020-2 の {応答コード})。
   *
   * @generated from field: repeated string credential_rejection_result_codes = 24;
   */
  credentialRejectionResultCodes: string[];

  /**
   * internalapi.v1.PlanSubmissionDetailView.send_retrying の pass-through
   * (AC-PLC-036)。
   *
   * @generated from field: bool send_retrying = 25;
   */
  sendRetrying: boolean;

  /**
   * 計画内不整合 (AC-IC-005) の需給バランスが 0 でないコマ番号 (1-origin, 昇順)。
   * 表示中の版の値で判定した結果で、空 = 判定対象外 (作成中・作成失敗) または
   * 不整合なし (AC-PPD-024)。
   * internalapi.v1.PlanSubmissionDetailView.internal_balance_mismatch_koma_numbers
   * の pass-through。
   *
   * @generated from field: repeated int32 internal_balance_mismatch_koma_numbers = 26;
   */
  internalBalanceMismatchKomaNumbers: number[];

  /**
   * 計画内不整合 (AC-IC-006) の BG 需要 ≠ Σ小売電気事業者別需要のコマ (表示中の版)。
   * 空 = 判定対象外または不整合なし (AC-PPD-025)。
   * internalapi.v1.PlanSubmissionDetailView.internal_retailer_demand_mismatches の
   * pass-through。
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanRetailerDemandMismatch internal_retailer_demand_mismatches = 27;
   */
  internalRetailerDemandMismatches: ProcurementPlanRetailerDemandMismatch[];

  /**
   * 表示中の版の提出期限 (AC-PLC-020-1)。未設定 = 期限を出さない断面 (当日・週間以降)。
   * internalapi.v1.PlanSubmissionDetailView.submission_deadline_at の pass-through。
   *
   * @generated from field: optional google.protobuf.Timestamp submission_deadline_at = 28;
   */
  submissionDeadlineAt?: Timestamp;

  /**
   * 作成時 (作成・XML 取込) に GC 済みだったため計画値を前回受理値 (無ければ 0)
   * にそろえたコマ番号 (1-origin, 昇順。AC-PLC-037-2)。空なら表示しない。
   * internalapi.v1.PlanSubmissionDetailView.creation_aligned_koma_numbers の
   * pass-through。
   *
   * @generated from field: repeated int32 creation_aligned_koma_numbers = 29;
   */
  creationAlignedKomaNumbers: number[];

  /**
   * error_category = BREAKDOWN_LIMIT_EXCEEDED の時だけ、作成失敗した時点の内訳件数の
   * 上限値 (AC-PLC-064 / AC-PLC-020-2)。
   * internalapi.v1.PlanSubmissionDetailView.breakdown_row_limit の pass-through。
   *
   * @generated from field: optional int32 breakdown_row_limit = 30;
   */
  breakdownRowLimit?: number;

  /**
   * 計画の対象日・エリアの、 スポットの約定結果が未着の札の件数 (AC-PPP-019)。 0 なら
   * 案内を出さない。 GetProcurementPlanDetail だけが詰め、 GetProcurementPlanByFilter
   * では常に 0 (filter 経路の consumer は詳細の id を得るためだけに使う)。
   *
   * @generated from field: int32 bids_awaiting_match_result_count = 31;
   */
  bidsAwaitingMatchResultCount: number;

  /**
   * この計画に「約定結果に合わせて計画を作り直してください」を出す時 true (AC-PPP-020)。
   * 計画 (単日 3 断面は同じ計画) の提出済・受領済・不整合のうち最新の版の JSPT3 の値が、
   * 提出後に届いたスポット約定量を取り込んだ値とコマ単位で違う時。計画単位の値で、
   * その計画のどの版の行・詳細にも同じ値が入る。
   * 未着の札のコマ (札の向きごと) と GC を過ぎたコマは比べない。需要調達計画の日次以外は false。
   *
   * @generated from field: bool spot_trade_result_mismatch = 32;
   */
  spotTradeResultMismatch: boolean;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanDetail.
 * Use `create(ProcurementPlanDetailSchema)` to create a new message.
 */
export const ProcurementPlanDetailSchema: GenMessage<ProcurementPlanDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 3);

/**
 * ProcurementPlanRetailerDemandMismatch is one koma where the BG 需要 differs
 * from the Σ小売電気事業者別需要 (AC-IC-006).
 *
 * @generated from message bffuser.v1.ProcurementPlanRetailerDemandMismatch
 */
export type ProcurementPlanRetailerDemandMismatch = Message<"bffuser.v1.ProcurementPlanRetailerDemandMismatch"> & {
  /**
   * 1-origin koma number (1..48).
   *
   * @generated from field: int32 koma_number = 1;
   */
  komaNumber: number;

  /**
   * BG 需要 − Σ小売電気事業者別需要 in kWh (never 0).
   *
   * @generated from field: int64 diff_kwh = 2;
   */
  diffKwh: bigint;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanRetailerDemandMismatch.
 * Use `create(ProcurementPlanRetailerDemandMismatchSchema)` to create a new message.
 */
export const ProcurementPlanRetailerDemandMismatchSchema: GenMessage<ProcurementPlanRetailerDemandMismatch> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 4);

/**
 * ProcurementPlanRetailer is one small retailer's breakdown used to render
 * the detail screen's BG/小売切替 (procurement-plan-retailer-breakdown
 * design).
 *
 * @generated from message bffuser.v1.ProcurementPlanRetailer
 */
export type ProcurementPlanRetailer = Message<"bffuser.v1.ProcurementPlanRetailer"> & {
  /**
   * 4-char OCCTO BusinessCd, the retailer's point-in-time submitted code.
   * The M22 JP06316 wire value is 5 digits (BusinessCd + 1-digit
   * areaSuffix); only the first 4 digits (BusinessCd) are persisted and
   * surfaced here (procurement retailer_code alignment: 4 char BusinessCd
   * 化, backend-derived pass-through of
   * internalapi.v1.PlanSubmissionRetailerView.retailer_code).
   *
   * @generated from field: string retailer_code = 1;
   */
  retailerCode: string;

  /**
   * JP06317, optional point-in-time name snapshot.
   *
   * @generated from field: optional string retailer_name = 2;
   */
  retailerName?: string;

  /**
   * Whether this retailer is the submitting entity itself (backend-derived
   * pass-through of internalapi.v1.PlanSubmissionRetailerView.is_own).
   *
   * @generated from field: bool is_own = 3;
   */
  isOwn: boolean;

  /**
   * 48 ordered demand slots. Empty when the retailer's demand section was
   * absent on import.
   *
   * @generated from field: repeated bffuser.v1.PlanSlot demand_slots = 4;
   */
  demandSlots: PlanSlot[];

  /**
   * Procurement breakdown rows. Empty when the retailer's procurement
   * section was absent on import, or carried no rows.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanValueRow procurement_values = 5;
   */
  procurementValues: ProcurementPlanValueRow[];

  /**
   * Sales breakdown rows. Empty when the retailer's sales section was absent
   * on import, or carried no rows.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanValueRow sales_values = 6;
   */
  salesValues: ProcurementPlanValueRow[];

  /**
   * Whether this retailer is the BG's 代表事業者 (backend-derived pass-through of
   * internalapi.v1.PlanSubmissionRetailerView.is_representative). is_own (送信者
   * が基準) とは別。代表事業者以外を選んでいる時は JEPX 市場列を出さない
   * (procurement-plan-detail.md AC-PPD-026)。
   *
   * @generated from field: bool is_representative = 7;
   */
  isRepresentative: boolean;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanRetailer.
 * Use `create(ProcurementPlanRetailerSchema)` to create a new message.
 */
export const ProcurementPlanRetailerSchema: GenMessage<ProcurementPlanRetailer> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 5);

/**
 * RetailerInfo is one member of the BG that owns a demand-procurement plan
 * submission, surfaced by GetProcurementPlanByFilter /
 * GetProcurementPlanDetail so the detail screen can render the BG / 小売
 * switch (procurement-plan-detail-filter design §5). It is a field subset of
 * internalapi.v1.BgMemberView: valid_from / valid_to are intentionally
 * dropped because the BFF handler filters to members effective on the
 * current day before returning this list (procurement-plan-detail-filter
 * design §6, ファイル構造 "Layer 間接続点").
 *
 * @generated from message bffuser.v1.RetailerInfo
 */
export type RetailerInfo = Message<"bffuser.v1.RetailerInfo"> & {
  /**
   * UUID of the linked business master record.
   *
   * @generated from field: string business_master_id = 1;
   */
  businessMasterId: string;

  /**
   * Denormalised business name snapshot.
   *
   * @generated from field: string business_name = 2;
   */
  businessName: string;

  /**
   * Whether this member is the own-company operator of the BG. Reserved for
   * a future self-first display ordering; not consumed by any AC as of this
   * slice.
   *
   * @generated from field: bool is_own = 3;
   */
  isOwn: boolean;
};

/**
 * Describes the message bffuser.v1.RetailerInfo.
 * Use `create(RetailerInfoSchema)` to create a new message.
 */
export const RetailerInfoSchema: GenMessage<RetailerInfo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 6);

/**
 * ProcurementPlanRow is the list-screen row returned by
 * ProcurementPlanService.ListProcurementPlans. It carries the fields
 * needed to render the demand-procurement plan list and derive UI badge
 * state.
 *
 * @generated from message bffuser.v1.ProcurementPlanRow
 */
export type ProcurementPlanRow = Message<"bffuser.v1.ProcurementPlanRow"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Planning horizon.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 2;
   */
  timeframe: PlanTimeframe;

  /**
   * The start date of the target period covered by this submission.
   *
   * @generated from field: google.type.Date target_period_start_date = 3;
   */
  targetPeriodStartDate?: Date;

  /**
   * Supply area this submission is bound to.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * OCCTO BG code of the balancing group.
   *
   * @generated from field: string bg_code = 5;
   */
  bgCode: string;

  /**
   * Display name of the balancing group. Absent when the BG master record
   * has been deleted.
   *
   * @generated from field: optional string bg_name = 6;
   */
  bgName?: string;

  /**
   * Current processing status as reported by the OCCTO portal.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 7;
   */
  status: PlanSubmissionStatus;

  /**
   * Submission version number. Starts at 1 and increments on each
   * re-submission.
   *
   * @generated from field: int32 version = 8;
   */
  version: number;

  /**
   * Timestamp at which the plan XML file was created (= file_created_at).
   *
   * @generated from field: google.protobuf.Timestamp file_created_at = 9;
   */
  fileCreatedAt?: Timestamp;

  /**
   * Timestamp at which the plan was submitted to the OCCTO portal.
   * Absent when the plan has not been submitted yet.
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 10;
   */
  submittedAt?: Timestamp;

  /**
   * Human-readable business key of the workflow case (業務ワークフロー) this
   * plan was created from (e.g. "R-D1-20260423-2E3B"). Empty string when the
   * plan is not linked to a workflow case (e.g. created via direct XML
   * upload).
   *
   * @generated from field: string workflow_id = 12;
   */
  workflowId: string;

  /**
   * Distinct trading-partner counterparties this plan procures from
   * (plan-common.md §連絡先モーダル). Rendered by the list screen's 取引先
   * column; each non-JEPX entry gets a phone icon that lazy-loads contact
   * details via OcctoMasterService.GetTradingPartnerContact on click
   * (AC-CM-001). May be empty.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanCounterparty counterparties = 13;
   */
  counterparties: ProcurementPlanCounterparty[];

  /**
   * OCCTO 受付エラー詳細 (BP エラーコード体系)。status = REJECTED かつ受付エラー
   * 詳細が取得済みの時のみ populate される。複数件は全件表示 (AC-PLC-033-1)。
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanReceptionError reception_errors = 14;
   */
  receptionErrors: ProcurementPlanReceptionError[];

  /**
   * 失敗原因の読み取り時分類。GENERATION_FAILED / SUBMIT_FAILED /
   * REJECTED(詳細なし) / SEND_FAILED (送信失敗の原因 4 区分) で populate、それ以外は
   * UNSPECIFIED
   * (internalapi.v1.PlanSubmissionSummaryView.error_category の pass-through)。
   *
   * @generated from field: bffuser.v1.ProcurementPlanSubmitErrorCategory error_category = 15;
   */
  errorCategory: ProcurementPlanSubmitErrorCategory;

  /**
   * GC 経過により送信時に自動除外されたコマ番号 (1-origin, 1..48, 昇順)。
   * internalapi.v1.PlanSubmissionSummaryView.excluded_koma_numbers の
   * pass-through (gc-excluded-koma-visibility design)。
   *
   * @generated from field: repeated int32 excluded_koma_numbers = 16;
   */
  excludedKomaNumbers: number[];

  /**
   * UUID of the workflow case backing workflow_id above (pass-through of
   * internalapi.v1.PlanSubmissionSummaryView.workflow_case_id). Used as the
   * navigation key for the list's ワークフローID link (/workflow/cases/:caseId,
   * AC-PPL-007a); the display value stays workflow_id
   * (ADR workflow-human-readable-id-separate-from-pk). Empty string when
   * unresolved — the row then renders workflow_id as plain text (or 「—」 when
   * workflow_id is empty too).
   *
   * Field number intentionally does NOT match internalapi's 18
   * Every other pass-through field in this message already carries a
   * consistent +1 offset from its internalapi counterpart (workflow_id
   * 13↔12, counterparties 14↔13, reception_errors 15↔14, error_category
   * 16↔15, excluded_koma_numbers 17↔16), so aligning only this new field
   * would break that established pattern rather than continue it. 17
   * continues the same offset.
   *
   * @generated from field: string workflow_case_id = 17;
   */
  workflowCaseId: string;

  /**
   * 整合ステータス of the plan this row belongs to (plan-common.md §一覧テーブルの
   * 「整合ステータス」列, AC-PPL-007b). Pass-through of
   * internalapi.v1.PlanSubmissionSummaryView.consistency_status; every row of
   * one plan carries the same value. The backend always sets a value other
   * than UNSPECIFIED (kinds without a consistency judgment are
   * NOT_EVALUATED); the frontend shows UNSPECIFIED like NOT_EVALUATED.
   * Field number continues the +1 offset of the fields above
   * (internalapi 19 ↔ 18).
   *
   * @generated from field: bfftypes.v1.PlanConsistencyStatus consistency_status = 18;
   */
  consistencyStatus: PlanConsistencyStatus;

  /**
   * 事業者コードが OCCTO 呼び出し回数上限 (0102) で受付照合を止めている間、
   * 提出済 / 受領確認待ちの処理中で true (AC-PLC-058)。
   * internalapi.v1.PlanSubmissionSummaryView.receipt_check_suspended_by_call_limit
   * の pass-through (field 番号は上の +1 offset を継続: internalapi 20 ↔ 19)。
   *
   * @generated from field: bool receipt_check_suspended_by_call_limit = 19;
   */
  receiptCheckSuspendedByCallLimit: boolean;

  /**
   * 最終更新日時 (AC-PLC-001 / AC-PLC-005) — pass-through of
   * internalapi.v1.PlanSubmissionSummaryView.last_updated_at (internalapi 21 ↔ 20).
   *
   * @generated from field: google.protobuf.Timestamp last_updated_at = 20;
   */
  lastUpdatedAt?: Timestamp;

  /**
   * internalapi.v1.PlanSubmissionSummaryView.send_retrying の pass-through
   * (AC-PLC-036)。
   *
   * @generated from field: bool send_retrying = 21;
   */
  sendRetrying: boolean;

  /**
   * internalapi.v1.PlanSubmissionSummaryView.counterparty_mismatches_all_resolved
   * の pass-through (internalapi 23 ↔ 22)。ステータス絞り込みで「不整合」を受領済に
   * 振り分ける条件 (plan-common.md §1「ステータス絞り込みの振り分け」)。
   *
   * @generated from field: bool counterparty_mismatches_all_resolved = 22;
   */
  counterpartyMismatchesAllResolved: boolean;

  /**
   * error_category = BREAKDOWN_LIMIT_EXCEEDED の時だけ、作成失敗した時点の内訳件数の
   * 上限値 (AC-PLC-064)。internalapi.v1.PlanSubmissionSummaryView.breakdown_row_limit
   * の pass-through (field 番号は上の +1 offset を継続: internalapi 24 ↔ 23)。
   *
   * @generated from field: optional int32 breakdown_row_limit = 23;
   */
  breakdownRowLimit?: number;

  /**
   * 行の対象日・エリアの、 スポットの約定結果が未着の札の件数 (AC-PPP-019。 数え方は
   * spot-bidding.md AC-BSP-101)。 0 なら案内を出さない。
   *
   * @generated from field: int32 bids_awaiting_match_result_count = 24;
   */
  bidsAwaitingMatchResultCount: number;

  /**
   * この計画に「約定結果に合わせて計画を作り直してください」を出す時 true (AC-PPP-020)。
   * 計画 (単日 3 断面は同じ計画) の提出済・受領済・不整合のうち最新の版の JSPT3 の値が、
   * 提出後に届いたスポット約定量を取り込んだ値とコマ単位で違う時。計画単位の値で、
   * その計画のどの版の行・詳細にも同じ値が入る。
   * 未着の札のコマ (札の向きごと) と GC を過ぎたコマは比べない。需要調達計画の日次以外は false。
   * internalapi.v1.PlanSubmissionSummaryView.spot_trade_result_mismatch の pass-through (番号は 24 を bids_awaiting_match_result_count が使うため 25)。
   *
   * @generated from field: bool spot_trade_result_mismatch = 25;
   */
  spotTradeResultMismatch: boolean;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanRow.
 * Use `create(ProcurementPlanRowSchema)` to create a new message.
 */
export const ProcurementPlanRowSchema: GenMessage<ProcurementPlanRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 7);

/**
 * ProcurementPlanCounterparty is one distinct trading-partner counterparty
 * surfaced within ProcurementPlanRow.counterparties.
 *
 * @generated from message bffuser.v1.ProcurementPlanCounterparty
 */
export type ProcurementPlanCounterparty = Message<"bffuser.v1.ProcurementPlanCounterparty"> & {
  /**
   * OCCTO 取引相手コード (includes JEPX market codes JSPT3 / J1HR3).
   *
   * @generated from field: string counterparty_code = 1;
   */
  counterpartyCode: string;

  /**
   * Display name. Absent when the trading partner name could not be
   * resolved (e.g. a 他社 BG master record was deleted).
   *
   * @generated from field: optional string counterparty_name = 2;
   */
  counterpartyName?: string;

  /**
   * Whether this counterparty is a JEPX market source (JEPX スポット /
   * JEPX 時間前). JEPX 経由取引先は個別連絡先を持たないため、frontend は
   * 電話アイコンを非表示にする (plan-common.md AC-CM-004).
   *
   * @generated from field: bool is_jepx = 3;
   */
  isJepx: boolean;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanCounterparty.
 * Use `create(ProcurementPlanCounterpartySchema)` to create a new message.
 */
export const ProcurementPlanCounterpartySchema: GenMessage<ProcurementPlanCounterparty> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 8);

/**
 * OCCTO 受付エラー詳細 (BP エラーコード体系。
 * internalapi.v1.PlanSubmissionReceptionError の BFF mirror)。status =
 * REJECTED かつ受付エラー詳細が取得済みの時のみ populate される。
 *
 * @generated from message bffuser.v1.ProcurementPlanReceptionError
 */
export type ProcurementPlanReceptionError = Message<"bffuser.v1.ProcurementPlanReceptionError"> & {
  /**
   * BP エラーコード (2桁, 例 "72")。
   *
   * @generated from field: string error_code = 1;
   */
  errorCode: string;

  /**
   * 常に空文字。受信確認メッセージ標準規格 (Ver.1.6 §5.3.2 表 5-3) には
   * エラーメッセージ文字列に相当するデータ要素が存在しないため
   * (plan-submit-reject-bp-error-code design Decision 6)。field はそのまま
   * 契約に残す (削除は破壊的変更で本件の scope 外。将来 OCCTO が別経路で
   * メッセージを返す受け皿としても残す)。
   *
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanReceptionError.
 * Use `create(ProcurementPlanReceptionErrorSchema)` to create a new message.
 */
export const ProcurementPlanReceptionErrorSchema: GenMessage<ProcurementPlanReceptionError> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_model, 9);

/**
 * 計画提出エラー分類 (internalapi.v1.PlanSubmitErrorCategory の BFF mirror、
 * 1:1)。backend の valueobject が単一箇所で分類する
 * (plansubmit-error-detail design Decision #3); converter / frontend は
 * 再導出しない。
 *
 * @generated from enum bffuser.v1.ProcurementPlanSubmitErrorCategory
 */
export enum ProcurementPlanSubmitErrorCategory {
  /**
   * エラーなし / 対象外 status。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 計画マスタ未設定 (需要調達/発電販売計画マスタ・発電BG・発電所マスタ・
   * BG/事業者マスタ)。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_PLAN_MASTER_MISSING = 1;
   */
  PLAN_MASTER_MISSING = 1,

  /**
   * 需要想定未確定。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_DEMAND_FORECAST_UNCONFIRMED = 2;
   */
  DEMAND_FORECAST_UNCONFIRMED = 2,

  /**
   * 値データ不足 (retailer データ欠落・値 build 失敗等)。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_SOURCE_DATA_INCOMPLETE = 3;
   */
  SOURCE_DATA_INCOMPLETE = 3,

  /**
   * OCCTO 認証情報未設定。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_CREDENTIAL_NOT_CONFIGURED = 4;
   */
  CREDENTIAL_NOT_CONFIGURED = 4,

  /**
   * transient リトライ上限到達。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_RETRY_EXHAUSTED = 5;
   */
  RETRY_EXHAUSTED = 5,

  /**
   * 未分類の permanent 失敗。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_OTHER = 6;
   */
  OTHER = 6,

  /**
   * All delivery komas passed gate close before a change plan could be sent.
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_GATE_CLOSED_ALL_KOMA = 7;
   */
  GATE_CLOSED_ALL_KOMA = 7,

  /**
   * OCCTO が認証情報・証明書を拒否した (登録済みだが認証が通らない)。
   * CREDENTIAL_NOT_CONFIGURED (未設定) とは原因も対処も異なる別カテゴリ
   * (occto-credential-error-send-failed design)。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_CREDENTIAL_INVALID = 8;
   */
  CREDENTIAL_INVALID = 8,

  /**
   * 送信失敗のうち OCCTO と通信できなかったもの (一過性エラーの再送上限到達・
   * 送信可能限界での終端・OCCTO 側障害コード)。status = SEND_FAILED の時だけ使う
   * (AC-PLC-050、 AC-PLC-052 注記)。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_OCCTO_UNREACHABLE = 9;
   */
  OCCTO_UNREACHABLE = 9,

  /**
   * 送信失敗のうち put で OCCTO API 呼び出し回数上限 (resultcode 0102) を受けた
   * もの。status = SEND_FAILED の時だけ使う (AC-PLC-052)。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_OCCTO_CALL_LIMIT_REACHED = 10;
   */
  OCCTO_CALL_LIMIT_REACHED = 10,

  /**
   * 作成失敗のうち、生成した計画の内訳件数が上限を超えたもの (AC-PLC-064)。
   * status = GENERATION_FAILED の時だけ使い、失敗時点の上限値を
   * breakdown_row_limit に伴う。
   *
   * @generated from enum value: PROCUREMENT_PLAN_SUBMIT_ERROR_CATEGORY_BREAKDOWN_LIMIT_EXCEEDED = 11;
   */
  BREAKDOWN_LIMIT_EXCEEDED = 11,
}

/**
 * Describes the enum bffuser.v1.ProcurementPlanSubmitErrorCategory.
 */
export const ProcurementPlanSubmitErrorCategorySchema: GenEnum<ProcurementPlanSubmitErrorCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_procurement_plan_model, 0);

/**
 * PlanSubmissionErrorReason mirrors internalapi.v1.PlanSubmissionErrorReason
 * 1:1 (same values, same numbers; pinned by go/internal/lint/filechecks/protocontract).
 *
 * @generated from enum bffuser.v1.PlanSubmissionErrorReason
 */
export enum PlanSubmissionErrorReason {
  /**
   * @generated from enum value: PLAN_SUBMISSION_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PLAN_SUBMISSION_ERROR_REASON_OCCTO_CREDENTIAL_NOT_CONFIGURED means the
   * submitting business entity's OCCTO credential is not registered on the
   * organization, so SubmitProcurementPlan's enqueue step rejects the
   * request with FailedPrecondition instead of queuing it.
   *
   * @generated from enum value: PLAN_SUBMISSION_ERROR_REASON_OCCTO_CREDENTIAL_NOT_CONFIGURED = 1;
   */
  OCCTO_CREDENTIAL_NOT_CONFIGURED = 1,

  /**
   * PLAN_SUBMISSION_ERROR_REASON_SUPERSEDED_VERSION means a newer version of
   * the same plan has already been handed to submission (AC-PLC-055).
   *
   * @generated from enum value: PLAN_SUBMISSION_ERROR_REASON_SUPERSEDED_VERSION = 2;
   */
  SUPERSEDED_VERSION = 2,

  /**
   * PLAN_SUBMISSION_ERROR_REASON_MISSING_BASELINE_BOXES means the version
   * lacks a counterparty box of the latest version OCCTO may hold
   * (AC-PLC-056).
   *
   * @generated from enum value: PLAN_SUBMISSION_ERROR_REASON_MISSING_BASELINE_BOXES = 3;
   */
  MISSING_BASELINE_BOXES = 3,
}

/**
 * Describes the enum bffuser.v1.PlanSubmissionErrorReason.
 */
export const PlanSubmissionErrorReasonSchema: GenEnum<PlanSubmissionErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_procurement_plan_model, 1);

/**
 * PlanSubmitBlockReason mirrors internalapi.v1.PlanSubmitBlockReason 1:1
 * (same values, same numbers).
 *
 * @generated from enum bffuser.v1.PlanSubmitBlockReason
 */
export enum PlanSubmitBlockReason {
  /**
   * Nothing blocks the submission, or the version is out of the judged scope.
   *
   * @generated from enum value: PLAN_SUBMIT_BLOCK_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A newer version of the same plan has already been handed to submission
   * (AC-PLC-055).
   *
   * @generated from enum value: PLAN_SUBMIT_BLOCK_REASON_SUPERSEDED_VERSION = 1;
   */
  SUPERSEDED_VERSION = 1,

  /**
   * The version that would be sent lacks a counterparty box of the latest
   * version OCCTO may hold (AC-PLC-056).
   *
   * @generated from enum value: PLAN_SUBMIT_BLOCK_REASON_MISSING_BASELINE_BOXES = 2;
   */
  MISSING_BASELINE_BOXES = 2,

  /**
   * The not-yet-submitted (GENERATED) version lacks a counterparty box and the
   * same plan has a newer version in the same business workflow, whether or
   * not that version carries the boxes (AC-PLC-056 / AC-PLC-062).
   * latest_plan_submission_id is set (the workflow's latest version).
   *
   * @generated from enum value: PLAN_SUBMIT_BLOCK_REASON_NEW_VERSION_CREATED = 3;
   */
  NEW_VERSION_CREATED = 3,
}

/**
 * Describes the enum bffuser.v1.PlanSubmitBlockReason.
 */
export const PlanSubmitBlockReasonSchema: GenEnum<PlanSubmitBlockReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_procurement_plan_model, 2);

